import React, { useRef, useEffect } from 'react';
import { createStyles, makeStyles } from '@mui/styles';
// import { Skeleton } from '@mui/material';
import MemberGroupListItem from './MemberGroupListItem';
import { GroupMemberHookReturn } from '../../hooks/useGroupMemberHook';
import { OrganizationCollection } from 'types/index';

const useStyles = makeStyles(() =>
    createStyles({
        listContainer: {
            width: '96%',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            paddingBottom: '64px'
        },
        errorContainer: {
            width: '96%',
            boxSizing: 'border-box',
            backgroundColor: 'white',
            border: '1px solid #E3E3FA',
            borderRadius: 10
        },
        errorText: {
            textAlign: 'left',
            color: '#1F2152',
            fontSize: '1.2rem',
            padding: '1em',
            margin: 0,
            fontWeight: 600
        },
        ariaLiveRegion: {
            position: 'absolute',
            left: '-10000px',
            width: '1px',
            height: '1px',
            overflow: 'hidden'
        }
    })
);

type MemberGroupListProps = {
    hook: GroupMemberHookReturn;
    collection: OrganizationCollection;
};

const MemberGroupList: React.FC<MemberGroupListProps> = ({hook, collection }) => {
    const classes = useStyles();
    const { fetchMembers } = hook;
    const ariaLiveRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleViewMembers = (groupId: number) => {
        fetchMembers(groupId);
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleFocusIn = (e: FocusEvent) => {
            const target = e.target as HTMLElement;
            const organizationItem = target.closest('[data-organization-name]') as HTMLElement;
            
            if (organizationItem) {
                const organizationName = organizationItem.getAttribute('data-organization-name');
                if (organizationName && ariaLiveRef.current) {
                    ariaLiveRef.current.textContent = `Viewing organization: ${organizationName}`;
                }
            }
        };

        container.addEventListener('focusin', handleFocusIn);
        return () => {
            container.removeEventListener('focusin', handleFocusIn);
        };
    }, [collection.name]);

    // const joinDeploymentNames = (deployments?: { name: string }[]) => {
    //     if (!deployments || deployments.length === 0) return [];
    //     return deployments.map(d => d.name);
    // };

    return (
        <>
            <div 
                ref={ariaLiveRef}
                className={classes.ariaLiveRegion}
                aria-live="polite"
                aria-atomic="true"
                role="status"
            />
            <div ref={containerRef} className={classes.listContainer}>
                {collection.organizations.map((group) => (
                    <MemberGroupListItem
                        key={"organization#" + group.id}
                        groupId={group.id}
                        title={group.name}
                        tags={[]}
                        onViewMembers={() => handleViewMembers(group.id)}
                        hook={hook}
                    />
                ))}
            </div>
        </>
    );
};

export default MemberGroupList; 